import Filters, { registerModuleFilters } from '@/utils/input/filters';

const { BaseFilters } = Filters;

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

const IsPublicFilter = {
  ...BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

const ShortenedUrlFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'shortenedUrlId',
  label: 'processPortal.form.shortenedUrl',
  apiRoute: 'shortenedUrl/paged',
  displayField: 'shortenedUrlCode',
  params: {
    select: 'id,shortenedUrlCode',
    filter: 'isActive eq true',
    orderBy: 'shortenedUrlCode asc',
  },
};

const UserCreatorFilter = {
  ...Filters.UserFilter,
  name: 'userCreatorId',
  label: 'global.userCreator',
};

const UserModifierFilter = {
  ...Filters.UserFilter,
  name: 'userModifierId',
  label: 'global.userModifier',
};

export const filtersConfig = [
  Filters.IsActiveFilter,
  IsPublicFilter,
  ShortenedUrlFilter,
  CreatedDateFilter,
  UserCreatorFilter,
  UpdatedDateFilter,
  UserModifierFilter,
];

registerModuleFilters('processPortal', filtersConfig);
